import React, { useState } from 'react'; // Added missing useState import
import { ShoppingBag, Gift, Star, Dumbbell } from 'lucide-react';
import { ProductCard } from '../components/shop/ProductCard';
import { RewardsBalance } from '../components/shop/RewardsBalance';
import { GymMembershipCard } from '../components/shop/GymMembershipCard';

const gymMemberships = [
  {
    id: 1,
    name: 'Gold\'s Gym',
    description: 'Premium membership with access to all facilities',
    location: 'Multiple Locations',
    originalPrice: 24999,
    discountedPrice: 19999,
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=800&q=80',
    features: ['All Equipment Access', 'Group Classes', 'Personal Training Session', 'Spa Access'],
    duration: '12 months'
  },
  {
    id: 2,
    name: 'Fitness First',
    description: 'Elite membership package with premium benefits',
    location: 'Nationwide Access',
    originalPrice: 29999,
    discountedPrice: 23999,
    image: 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=800&q=80',
    features: ['24/7 Access', 'CrossFit Area', 'Nutrition Consultation', 'Swimming Pool'],
    duration: '12 months',
    popular: true
  }
];

const products = [
  {
    id: 1,
    name: 'Whey Protein Isolate',
    description: 'Premium protein powder for muscle recovery',
    price: 2999,
    image: 'https://images.unsplash.com/photo-1593095948071-474c5cc2989d?w=800&q=80',
    rating: 4.8,
    category: 'supplements'
  },
  {
    id: 2,
    name: 'Resistance Bands Set',
    description: 'Professional grade resistance bands for versatile workouts',
    price: 1499,
    image: 'https://images.unsplash.com/photo-1598289431512-b97b0917affc?w=800&q=80',
    rating: 4.5,
    category: 'equipment'
  },
  {
    id: 3,
    name: 'Recovery Massage Ball',
    description: 'Deep tissue massage ball for muscle recovery',
    price: 899,
    image: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800&q=80',
    rating: 4.7,
    category: 'recovery'
  },
  {
    id: 4,
    name: 'Smart Water Bottle',
    description: 'Track your hydration with smart reminders',
    price: 1999,
    image: 'https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=800&q=80',
    rating: 4.3,
    category: 'accessories'
  }
];

export function ShopPage() {
  const [points, setPoints] = useState(2500); // Example points balance

  const handleUsePoints = (usedPoints: number) => {
    setPoints(prev => prev - usedPoints);
  };

  return (
    <div className="container mx-auto px-4 py-6 pt-20 pb-24">
      <div className="space-y-8">
        {/* Header */}
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">Shop</h1>
          <RewardsBalance points={points} />
        </div>

        {/* Premium Gym Memberships */}
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Dumbbell className="w-6 h-6 text-primary" />
              <h2 className="text-xl font-semibold">Premium Gym Memberships</h2>
            </div>
            <div className="text-sm text-primary">Exclusive Discounts for Premium Users</div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {gymMemberships.map(membership => (
              <GymMembershipCard key={membership.id} membership={membership} />
            ))}
          </div>
        </div>

        {/* Regular Products */}
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <ShoppingBag className="w-6 h-6 text-primary" />
            <h2 className="text-xl font-semibold">Shop Products</h2>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {products.map(product => (
              <ProductCard 
                key={product.id} 
                product={product} 
                points={points}
                onUsePoints={handleUsePoints}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}